import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Radio } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export default function AartiStream() {
  const [cfg, setCfg] = useState(null);
  const { t } = useLang();

  useEffect(() => { api.get("/settings/live-aarti").then((r) => setCfg(r.data)); }, []);

  if (!cfg) return null;
  const vid = cfg.youtube_video_id?.trim();

  return (
    <section data-testid="aarti-stream" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-28">
      <div className="grid lg:grid-cols-5 gap-8 items-center">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="relative flex h-3 w-3">
              <span className={`absolute inline-flex h-full w-full rounded-full ${vid ? "bg-red-500 animate-ping" : "bg-amber-400"} opacity-75`}></span>
              <span className={`relative inline-flex rounded-full h-3 w-3 ${vid ? "bg-red-500" : "bg-amber-500"}`}></span>
            </span>
            <span className="overline">{vid ? t("aarti.live") : "Live Aarti"}</span>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-[#4A0E17] mt-3 leading-tight">{cfg.title}</h2>
          <p className="text-[#63534E] mt-5 leading-relaxed">
            Witness darshan at Pancham Dham from anywhere in the world. Live aarti is streamed daily — join thousands of devotees chanting together.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 bg-[#F3E5AB]/40 border border-[#D4AF37]/40 rounded-full px-4 py-2 text-sm text-[#4A0E17]">
            <Radio className="w-4 h-4 text-[#E65100]" />
            <span className="font-mono">{cfg.schedule}</span>
          </div>
        </div>
        <div className="lg:col-span-3 relative aspect-video rounded-3xl overflow-hidden sacred-border bg-[#4A0E17]">
          {vid ? (
            <iframe
              data-testid="aarti-iframe"
              className="absolute inset-0 w-full h-full"
              src={`https://www.youtube.com/embed/${vid}?rel=0&autoplay=0`}
              title="Pancham Dham Live Aarti"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          ) : (
            <div data-testid="aarti-offline" className="absolute inset-0 flex flex-col items-center justify-center text-[#F3E5AB] p-8 text-center">
              <div className="font-devanagari text-[120px] leading-none text-[#D4AF37] opacity-20">ॐ</div>
              <div className="font-serif text-2xl text-[#F3E5AB] mt-4">{cfg.offline_message}</div>
              <div className="text-sm text-[#F3E5AB]/70 mt-3">{cfg.schedule}</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
